import { SET_DRIVER_ATTRIBUTE } from 'vx/mutations'

export default {
  computed: {
    user: {
      get () {
        return this.driver.user_id
      },

      set (value) {
        this[SET_DRIVER_ATTRIBUTE]({ attribute: 'user_id', value })
      }
    },

    name: {
      get () {
        return this.driver.name
      },

      set (value) {
        this[SET_DRIVER_ATTRIBUTE]({ attribute: 'name', value })
      }
    },

    mobile: {
      get () {
        return this.driver.mobile
      },

      set (value) {
        this[SET_DRIVER_ATTRIBUTE]({ attribute: 'mobile', value })
      }
    },

    email: {
      get () {
        return this.driver.email
      },

      set (value) {
        this[SET_DRIVER_ATTRIBUTE]({ attribute: 'email', value })
      }
    },

    licence: {
      get () {
        return this.driver.licence
      },

      set (value) {
        this[SET_DRIVER_ATTRIBUTE]({ attribute: 'licence', value })
      }
    },

    licenceExpiry: {
      get () {
        return this.driver.licence_expiry
      },

      set (value) {
        this[SET_DRIVER_ATTRIBUTE]({ attribute: 'licence_expiry', value })
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/drivers/state-mapper.js